// #1137 follow-up (owner, 2026-10-31) -- special characters a chemist writes by an arrow, in
// notes and in captions: offered on a Symbols grid, and the common ones typed as shortcuts.

/** The Symbols grid, in reading order: conditions, arrows, Greek, charges and the rest. */
export const CHEMISTRY_SYMBOLS: readonly string[] = [
  '°',
  'Δ',
  'hν',
  '±',
  '→',
  '⇌',
  '⇄',
  '↑',
  '↓',
  '‡',
  '≈',
  '×',
  '·',
  '•',
  '⁺',
  '⁻',
  'α',
  'β',
  'γ',
  'δ',
  'λ',
  'µ',
  'ν',
  'π',
  'σ'
];

/** Names typed after a backslash, as in TeX: `\Delta` and a space gives Δ. */
const NAMED: Readonly<Record<string, string>> = {
  deg: '°',
  Delta: 'Δ',
  delta: 'δ',
  hv: 'hν',
  nu: 'ν',
  mu: 'µ',
  pm: '±',
  to: '→',
  eq: '⇌',
  up: '↑',
  down: '↓',
  dagger: '‡',
  approx: '≈',
  times: '×',
  cdot: '·',
  alpha: 'α',
  beta: 'β',
  gamma: 'γ',
  lambda: 'λ',
  pi: 'π',
  sigma: 'σ'
};

/**
 * The shortcut the text just typed completes, if any: the last `length` characters of `before`
 * (the text up to the caret, the typed character last) become `symbol`. "->" → "→", "<=>" → "⇌",
 * "+-" → "±", "80 degC" → "80 °C", and `\name ` for any name in the table.
 */
export function symbolShortcut(before: string): { readonly length: number; readonly symbol: string } | null {
  if (before.endsWith('<=>')) return { length: 3, symbol: '⇌' };
  if (before.endsWith('->')) return { length: 2, symbol: '→' };
  if (before.endsWith('+-')) return { length: 2, symbol: '±' };
  const degrees = /\ddeg([CF])$|\d deg([CF])$/.exec(before);
  if (degrees) return { length: 4, symbol: `°${degrees[1] ?? degrees[2]}` };
  const named = /\\([A-Za-z]+) $/.exec(before);
  const symbol = named && NAMED[named[1]!];
  return symbol ? { length: named[0].length, symbol } : null;
}
